"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMentionContext = exports.MentionProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
// Define the context and type

var MentionContext = /*#__PURE__*/(0, _react.createContext)(undefined);

// Provider component
var MentionProvider = function MentionProvider(_ref) {
  var children = _ref.children;
  var _ref2 = (0, _react.useState)([]),
    _ref3 = _slicedToArray(_ref2, 2),
    peopleMentions = _ref3[0],
    setPeopleMentions = _ref3[1];
  var _ref4 = (0, _react.useState)([]),
    _ref5 = _slicedToArray(_ref4, 2),
    labelMentions = _ref5[0],
    setLabelMentions = _ref5[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MentionContext.Provider, {
    value: {
      peopleMentions: peopleMentions,
      setPeopleMentions: setPeopleMentions,
      labelMentions: labelMentions,
      setLabelMentions: setLabelMentions
    },
    children: children
  });
};

// Custom hook to use the context
exports.MentionProvider = MentionProvider;
var useMentionContext = function useMentionContext() {
  var context = (0, _react.useContext)(MentionContext);
  if (!context) {
    throw new Error('useMentionContext must be used within a MentionProvider');
  }
  return context;
};
exports.useMentionContext = useMentionContext;